import { Fragment } from "react";
import { useDispatch } from "react-redux";
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

import ImgModal from '../../../components/modals/ImgModal';
import { open, updateImgInformations } from '../../../redux/features/imgModalSlice'

import i18n from '../../../i18n/i18n';

import BeachFront from '../../../assets/BeachFront.webp';
import BeachLeft from '../../../assets/BeachLeft.webp';
import BeachRight from '../../../assets/BeachRight.webp';
import BikePath from '../../../assets/BikePath.webp';
import ChristmasCamper from '../../../assets/ChristmasCamper.webp';
import ChristmasCamperATV from '../../../assets/ChristmasCamperATV.webp';
import Garden from '../../../assets/Garden.webp';
import HockeyRink from '../../../assets/HockeyRink.webp';
import Mascot from '../../../assets/Mascot.webp';
import NoService from '../../../assets/NoService.webp';
import NorthSites from '../../../assets/NorthSites.webp';
import ObservationPoint from '../../../assets/ObservationPoint.webp';
import ObservationPointSunset from '../../../assets/ObservationPointSunset.webp';
import OrangeSunset from '../../../assets/OrangeSunset.webp';
import Reception from '../../../assets/Reception.webp';
import Sunset from '../../../assets/Sunset.webp';
import SunSetVertical from '../../../assets/SunSetVertical.webp';
import StLawrenceRiverBeach from '../../../assets/StLawrenceRiverBeach.webp';

const style = {
  cursor:'pointer'
};

export default function PhotosGallery() {
  const { t } = i18n;
  const dispatch = useDispatch();
  function handleOpen(src, title) {
    dispatch(updateImgInformations({src, title}));
    dispatch(open(true));
  }

  return(
    <Fragment>
      <Divider sx={{mt: {xs:5, md:10}, mb:4}} id='photos'>
        <Stack>
          <Typography variant='h5'>
          {t('photos.secondary')}
          </Typography>
          <Typography 
              variant='h4'
              sx={{
                  letterSpacing:'-0.05em',
                  fontWeight:600,
              }}
          >
            {t('photos.main')}
          </Typography>
        </Stack>
      </Divider>
      <Container maxWidth='xl'>
        <Box sx={{ width: '100%'}}>
          <ImageList sx={{ height: 600 }} cols={4} gap={8}>
            {itemData.map((item, i) => (
              <ImageListItem key={i}>
                <img
                    src={item.img}
                    srcSet={item.img}
                    alt={item.title}
                    onClick={(e) => handleOpen(e.target.src, e.target.alt)}
                    style={style}
                    loading="lazy"
                  />
              </ImageListItem>
            ))}
          <ImgModal />
          </ImageList>
        </Box>
      </Container>
      <Divider sx={{mt: 5}} />
    </Fragment>
  );
}

const itemData = [
  {
    img: Reception,
    title: 'Campsites',
  },
  {
    img: NorthSites,
    title: 'Sunset',
  },
  {
    img: StLawrenceRiverBeach,
    title: 'Campsites',
  },
  {
    img: ObservationPoint,
    title: 'Another Sunset',
  },
  {
    img: NoService,
    title: 'Mascot Lucky',
  },

  {
    img: HockeyRink,
    title: 'Observation Point',
  },
  {
    img: Garden,
    title: 'Christmas Camper ATV',
  },
  {
    img: BeachLeft,
    title: 'Bike Path',
  },
  {
    img: BeachFront,
    title: 'Campsites',
  },
  {
    img: BeachRight,
    title: 'Christmas Camper train',
  },
  {
    img: ObservationPointSunset,
    title: 'Observation Point',
  },
  {
    img: OrangeSunset,
    title: 'Sunset',
  },
  {
    img: Sunset,
    title: 'Another Sunset',
  },
  {
    img: BikePath,
    title: 'Bike Path',
  },
  {
    img: SunSetVertical,
    title: 'Sunset',
  },
  {
    img: Mascot,
    title: 'Mascot Lucky',
  },
  {
    img: ChristmasCamper,
    title: 'Christmas Camper train',
  },
  {
    img: ChristmasCamperATV,
    title: 'Christmas Camper ATV',
  },
];